import React from 'react';
import { COLORS } from '../../../../../utils/colors';


const TreeToppingGroupElement = (props) => {
  const { toppingGroup } = props;

  const square = '40px';

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        opacity: toppingGroup.active ? 1 : 0.3,
        marginLeft: '-4px',
        borderLeft: `2px solid ${COLORS.INFO}`,
        // borderRadius: '4px',
        padding: '8px',
        backgroundColor: `${COLORS.INFO}05`,
        boxShadow: '0px 6px 8px -3px #00000040',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', fontSize: '0.9rem' }}>
        <div
          style={{
            fontWeight: 'bold',
            letterSpacing: '-0.024em',
            marginRight: '10px',
            fontSize: '0.64rem',
            width: '6px',
            height: '6px',
            borderRadius: '100px',
            backgroundColor: COLORS.INFO,
          }}
        />
        <div style={{ width: square, height: square, background: '#f50057', borderRadius: '4px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <span style={{ fontSize: '20px', fontWeight: 'bold', color: 'white' }}>TG</span>
        </div>
        <div style={{ fontWeight: 'bold', letterSpacing: '-0.024em', marginLeft: '10px' }}>
          {toppingGroup.name}
        </div>
      </div>
    </div>
  );
};

export default TreeToppingGroupElement;
